// extracted by mini-css-extract-plugin
export default {"listitemlabel":"ListItemLabel_listitemlabel__QX+al"};